<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#0074FF">
        <g>
          <g>
            <g>
              <path
                d="M6.869.162c-.166-.18-.435-.212-.635-.085L6.162.13l-6 5.5c-.192.177-.213.465-.064.667l.064.07 6 5.5c.204.187.52.173.707-.03.165-.181.173-.451.03-.64l-.061-.067L1.24 6 6.838.869c.18-.166.212-.435.085-.635L6.87.162z"
                transform="translate(-20 -26) translate(20 12) translate(0 14) translate(2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ChevronLeftIcon',
  props: {
    height: VueTypes.string.def('12'),
    width: VueTypes.string.def('12'),
  },
};
</script>

<style lang="scss"></style>
